export const HEADER_TITLE = 'Summary';
